import { Ring } from "../demo-v2/chrome/ring.js";
import { KuoriLogo } from "../shared/logo.js";
import type { WallCopy } from "./content.js";
import { COVER, type WallPhoto } from "./photos.js";

export interface WallFeature {
  readonly key: string;
  readonly src: string;
  readonly author: string;
}

export interface WallProps {
  readonly copy: WallCopy;
  readonly host: string;
  readonly count: number;
  readonly featured: WallFeature | null;
  readonly recent: readonly WallPhoto[];
  readonly accent?: string;
  readonly waiting?: boolean;
  readonly remaining?: number;
}

export function Wall({
  copy,
  host,
  count,
  featured,
  recent,
  accent = "currentColor",
  waiting = false,
  remaining = 0.62,
}: WallProps) {
  return (
    <div class="tv" role="img" aria-label={copy.label}>
      <div class="tv-screen" data-theme="dark">
        <div class="tv-head">
          <div class="tv-host">
            <span class="tv-name" data-testid="tv-host">
              {host}
            </span>
            <span class="tv-live">{copy.live}</span>
          </div>
          <div class="tv-stats">
            <div class="tv-count">
              <span class="tv-micro">{copy.count}</span>
              <strong data-testid="tv-count">{count}</strong>
            </div>
            <Ring size={34} stroke={2.5} fraction={remaining} color={accent}>
              <span class="tv-ring-label">2h</span>
            </Ring>
          </div>
        </div>
        <div class={waiting ? "tv-stage is-waiting" : "tv-stage"}>
          {waiting ? (
            <figure class="tv-wait" data-testid="tv-waiting">
              <img src={COVER} alt="" loading="lazy" />
              <figcaption>
                <strong>{copy.waiting}</strong>
                <span>
                  {count} {copy.kept}
                </span>
              </figcaption>
            </figure>
          ) : (
            <>
              {featured ? (
                <figure class="tv-featured" key={featured.key} data-testid="tv-featured">
                  <img src={featured.src} alt="" loading="lazy" />
                  <figcaption>
                    <span class="tv-micro">{copy.now}</span>
                    <strong>{featured.author}</strong>
                  </figcaption>
                </figure>
              ) : null}
              <div class="tv-tiles">
                {recent.slice(0, 6).map((photo) => (
                  <img key={photo.id} class="tv-tile" src={photo.small} alt="" loading="lazy" />
                ))}
              </div>
            </>
          )}
          <div class="tv-join" data-theme="light">
            <img src="/assets/demo/qr.svg" alt="" width={64} height={64} loading="lazy" />
            <div>
              <p class="tv-code">DEMO 2026</p>
              <p class="tv-join-text">{copy.join}</p>
              <span class="tv-point">{copy.point}</span>
            </div>
          </div>
        </div>
        <div class="tv-foot">
          {copy.madeWith} <KuoriLogo height={12} />
        </div>
      </div>
    </div>
  );
}
